import React from "react";
import { cn } from "@synthesis/shared-utils";
import { jsx } from "react/jsx-runtime";
import { get, useFormState } from "react-hook-form";
//#region src/Input/ErrorContainer.tsx
const ErrorContainer = React.memo(({ inputRef, control, name, error }) => {
	const formState = useFormState({
		control,
		name
	});
	const isDirty = get(formState.dirtyFields, name);
	React.useEffect(() => {
		if (!inputRef.current) return;
		if (error) {
			inputRef.current.classList.add("input-error");
			return;
		}
		inputRef.current.classList.remove("input-error");
	}, [
		error,
		inputRef,
		isDirty
	]);
	if (!error) return null;
	return /* @__PURE__ */ jsx("p", {
		"data-cy": "inputComponent-p",
		className: cn("text-system-error-50 mt-[.125rem]"),
		children: error
	});
});
ErrorContainer.displayName = "ErrorContainer";
//#endregion
export { ErrorContainer };

//# sourceMappingURL=ErrorContainer.js.map